import React from "react";
import { ReactComponent as Media1 } from "./assets/images/jawapos.svg";
import { ReactComponent as Media2 } from "./assets/images/jpnn.svg";
import { ReactComponent as Media3 } from "./assets/images/kumparan.svg";
import { ReactComponent as Media4 } from "./assets/images/okezone.svg";
import { ReactComponent as Media5 } from "./assets/images/republika.svg";
import { ReactComponent as Media6 } from "./assets/images/tribun.svg";
import { ReactComponent as Media7 } from "./assets/images/bi.svg";
import { ReactComponent as Media8 } from "./assets/images/kompas.svg";
import { ReactComponent as Media9 } from "./assets/images/beritasatu.svg";
import { ReactComponent as Media10 } from "./assets/images/liputan6.svg";
import { ReactComponent as Media11 } from "./assets/images/indonesia.svg";
import { ReactComponent as Media12 } from "./assets/images/sindo.svg";
import { ReactComponent as Media13 } from "./assets/images/rm.svg";
import { ReactComponent as Media14 } from "./assets/images/warta.svg";
import { ReactComponent as Media15 } from "./assets/images/investor.svg";
import { ReactComponent as Media16 } from "./assets/images/antara.svg";
import { ReactComponent as Media17 } from "./assets/images/harapan.svg";
import { ReactComponent as Media18 } from "./assets/images/aktual.svg";

const Media = () => {
  return (
    <div>
      <h1 className="text-center text-3xl font-bold mt-10 md:mt-0">
        Telah diliput oleh media terpercaya
      </h1>
      <div className="grid grid-cols-2 gap-4 wrapper md:grid-cols-4">
        <a href="https://ekonomi.bisnis.com/read/20210826/98/1434547/ini-rahasia-trawlbens-bisa-hadirkan-tarif-murah-jasa-logistik">
        <Media7 className="w-11/12" /></a>
        <a href="

https://money.kompas.com/read/2021/08/25/205333326/bos-aplikasi-trawlbens-ungkap-rahasia-jasa-pengiriman-bertarif-murah?page=all">
        <Media8 className="w-11/12" /></a>

        <a href="https://kumparan.com/beritaanaksurabaya/trawlbens-jasa-ekspedisi-kargo-aman-dan-terpercaya-1xKCunnc61v/full">
        <Media3 className="w-11/12" /></a>

        <a href="https://news.okezone.com/read/2022/01/17/1/2533494/trawlbens-berikan-layanan-aman-dan-terjangkau-ke-seluruh-indonesia">
        <Media4 className="w-11/12" />
        </a>

        <a href="https://www.tribunnews.com/bisnis/2021/11/23/gandeng-mitra-baru-trawlbens-siap-beroperasi-di-yogyakarta-makassar-dan-batam">
        <Media6 className="w-11/12 mb-12" />
        </a>

        <a href="https://www.republika.co.id/berita/r30q9l291/trawlbens-tambah-delapan-jaringan-kemitraan-kota-besar">
        <Media5 className="w-11/12" />
        </a>

        <a href="https://www.jpnn.com/news/trawlbens-tawarkan-layanan-pengiriman-murah-untuk-umkm">
        <Media2 className="w-11/12" />
        </a>

        <a href="https://www.jawapos.com/ekonomi/bisnis/24/11/2021/trawlbens-ekspansi-tambah-8-jaringan-kemitraan-di-sejumlah-kota/">
        <Media1 className="w-11/12" />
        </a>

        <a href="https://www.beritasatu.com/ekonomi/816461/bisnis-logistik-cerah-trawlbens-gencar-gandeng-mitra-bisnis">
        <Media9 className="w-11/12 mb-12" />
        </a>

        <a href="https://www.liputan6.com/tekno/read/4397452/trawlbens-aplikasi-logistik-yang-janjikan-tarif-murah-untuk-umkm">
        <Media10 className="w-11/12" />
        </a>

        <a href="https://indonesiainside.id/ekonomi/2021/11/24/trawlbens-tambah-kemitraan-di-8-kota-besar">
        <Media11 className="w-11/12" />
        </a>

        <a href="https://ekbis.sindonews.com/read/421446/34/trawlbens-tawarkan-solusi-pengiriman-semurah-china-1620381936">
        <Media12 className="w-11/12" />
        </a>


        <a href="https://rm.id/baca-berita/ekonomi-bisnis/101286/bisnis-logistik-moncer-trawlbens-perluas-jaringan-di-kota-besar">
        <Media13 className="w-11/12 mb-12" /></a>

        <a href="https://wartaekonomi.co.id/read318830/beni-syarifudin-dari-ob-jadi-ceo-trawlbens">
        <Media14 className="w-11/12" /></a>

        <a href="https://investor.id/business/230881/trawlbens-menjadi-pengusaha-logistik-tak-perlu-modal-besar">
        <Media15 className="w-11/12" /></a>

        <a href="https://www.antaranews.com/berita/1793613/trawlbens-peluang-usaha-kemitraan-logistik">
        <Media16 className="w-11/12" /></a>

        <a href="https://www.harapanrakyat.com/2021/09/startup-logistik-trawlbens-tawarkan-pengiriman-dengan-harga-murah/">
        <Media17 className="w-11/12 mb-12" /></a>

        <a href="https://aktual.com/gelar-pelatihan-trawlbens-bekali-mitra-bisnis-dengan-ilmu-logistik/">
        <Media18 className="w-11/12" /></a>
      </div>
    </div>
  );
};

export default Media;
